// SDK name and version, sent in `sdk.{name,version}` of every payload and
// in the `User-Agent`. Keep `SDK_VERSION` aligned with `version` in package.json.
export const SDK_NAME = 'closeyourit-js'
export const SDK_VERSION = '0.14.24'

// `platform` of Sentry events and `contexts.runtime.name`.
export const PLATFORM = 'javascript'
